import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';

type OrderReviewSelectFilterProps = {
    label: string;
    optionSelected?: string;
    options: string[];
    onOptionChange: (option: string) => void;
    translationNamespace?: string;
};
const OrderReviewSelectFilter: FC<OrderReviewSelectFilterProps> = ({
    label,
    optionSelected,
    options,
    onOptionChange,
    translationNamespace,
}: OrderReviewSelectFilterProps) => {
    const { t: translate } = useTranslation(['invoices', 'orders']);
    const handleOptionChange = (event: SelectChangeEvent<string>) => {
        onOptionChange(event.target.value);
    };
    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select label={label} value={optionSelected} onChange={handleOptionChange}>
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {translate(`${translationNamespace ? translationNamespace : 'invoices'}:${option}`)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default OrderReviewSelectFilter;
